import { Image } from "@blacknut/javascript-sdk/dist";
import { Reducer } from "redux";
import { PassAction, PassActionTypes } from "../actions";
export interface State {
  passImages: Record<string, Image[]>;
}
const initialState: State = {
  passImages: {},
};

export const reducer: Reducer<State> = (state = initialState, action: PassAction) => {
  switch (action.type) {
    case PassActionTypes.PASS_GET_IMAGES_SUCCESS: {
      return {
        ...state,
        passImages: { ...state.passImages, [action.passId]: action.images },
      };
    }
    default:
      return state;
  }
};
